import { isArchivingNotificationDismissable } from 'components/archiving/utils';
import type { BackgroundJobDTO } from 'components/backgroundjobs/backgroundJobs';
import { JobTypeDTO } from 'components/main/Setup/Imaging/ImageManagementTask/constants';
import connectionHubManager from 'connectionHub/connectionHubManager';
import type { AppDispatch, RootState } from 'redux/configureStore';
import {
  removeBackGroundJob,
  removeCompletedBackgroundJob,
} from 'redux/reducers/backgroundJobsReducer';

const PROGRESS_HUB_NAME = 'progresshub';
const PROGRESS_HUB_PATH = '/progressHub';

const ARCHIVING_JOB_TYPES = [JobTypeDTO.Archiving, JobTypeDTO.Unarchive];

const isClearableBackgroundJob = (job: BackgroundJobDTO) =>
  job.progress === 100 ||
  (ARCHIVING_JOB_TYPES.includes(Number(job.jobType)) &&
    isArchivingNotificationDismissable(job));

const removeJobOnServer = async (job: { id: number | string; type: number }) => {
  try {
    const connection = await connectionHubManager.getConnection(
      PROGRESS_HUB_NAME,
      PROGRESS_HUB_PATH,
    );
    await connection.invoke('RemoveJob', job.id, job.type);
  } catch (error) {
    console.error('Failed to remove background job on the server:', error);
  }
};

export const dismissBackgroundJobThunk =
  (job: { id: number | string; type: number }) => async (dispatch: AppDispatch) => {
    await removeJobOnServer(job);
    dispatch(removeBackGroundJob(job));
  };

export const clearCompletedBackgroundJobsThunk =
  () => async (dispatch: AppDispatch, getState: () => RootState) => {
    const clearableJobs = getState().backgroundJobs.backgroundJobs.filter(
      isClearableBackgroundJob,
    );

    await Promise.all(
      clearableJobs.map((job) => removeJobOnServer({ id: job.jobId, type: job.jobType })),
    );

    dispatch(removeCompletedBackgroundJob());
    clearableJobs
      .filter((job) => job.progress !== 100)
      .forEach((job) =>
        dispatch(removeBackGroundJob({ id: job.jobId, type: job.jobType })),
      );
  };
